import { AnchorIds, TourIds, TourSignal } from "../TourTypes";
import { ArrowPosition } from "../StickyNote";

/**
 * Initial onboarding for users who did not import a manuscript: a chat
 * conversation opens with a personalized message.
 * A single sticky points at the chat sidebar so the user knows where their
 * writing partner lives, then dismisses on the next click anywhere.
 */
const CHAT_ONBOARDING_TOUR = {
  id: TourIds.CHAT_ONBOARDING,
  steps: [
    {
      id: "1",
      stickies: [
        {
          content: "Nice to meet you! I'm Sudowrite, and you can talk to me over here.", // pragma: allowlist secret
          offsetX: -260,
          offsetY: 120,
          anchorId: AnchorIds.RIGHT_BAR,
          arrowPosition: ArrowPosition.TopRight,
          rotation: -3,
        },
      ],
      listeningFor: [TourSignal.GLOBAL_CLICK],
    },
  ],
};

export { CHAT_ONBOARDING_TOUR };
